import React from "react";
import { Handshake, MessagesSquare, Banknote, Trophy, Star, PhoneCall, Rocket, Award } from "lucide-react";

const ICONS = {
  handshake: Handshake,
  messages: MessagesSquare,
  banknote: Banknote,
  trophy: Trophy,
  star: Star,
  "phone-call": PhoneCall,
  rocket: Rocket,
};

export const BadgePill = ({ badge, lang = "es", size = "md" }) => {
  const Icon = ICONS[badge.icon] || Award;
  const s = size === "sm" ? "px-2 py-1 text-xs" : "px-3 py-1.5 text-sm";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border-2 border-black font-display font-bold ${s}`}
      style={{ background: badge.color, color: "#fff" }}
      title={badge[`label_${lang}`]}
    >
      <Icon className="w-4 h-4" />
      {badge[`label_${lang}`]}
    </span>
  );
};

export const TierChip = ({ tier, lang = "es" }) => (
  <div className="inline-flex items-center gap-2 brutal-sm bg-canales-yellow px-3 py-1">
    <div className="flex">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          className={`w-4 h-4 ${i < tier.stars ? "fill-black text-black" : "text-neutral-400"}`}
        />
      ))}
    </div>
    <span className="font-display font-black text-sm">{tier[`label_${lang}`]}</span>
  </div>
);
